import React, { PureComponent } from "react";
import { PropTypes } from "prop-types";
import { Button, Icon } from "semantic-ui-react";

import { VIEW_MODES } from "/constants/modes.js";

class EditButton extends PureComponent {
  static propTypes = {
    mode: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    disabled: PropTypes.bool.isRequired,
    floated: PropTypes.string,
    className: PropTypes.string
  };

  static defaultProps = {
    mode: VIEW_MODES.EDIT,
    disabled: false
  };

  render() {
    const { mode, disabled, floated, className, onClick } = this.props;

    const iconName = "edit";
    // const iconName = mode === VIEW_MODES.EDIT ? "times" : "edit";

    return (
      <Button
        icon
        basic
        circular
        disabled={disabled}
        floated={floated}
        onClick={onClick}
        className={className}
      >
        <Icon name={iconName} />
      </Button>
    );
  }
}

export default EditButton;
